import * as React from 'react';
import Dropdown from './NBDropdown';
import Styles from '../Styles';
import type {MenuOption} from 'src/types/MenuOption';
import {CountryArray} from 'src/constants/Countries';
type CountryDropdownProps = {
  selectedValue: string;
  onSelect: (value: string) => void;
};
export default function CountryDropdown(props: CountryDropdownProps) {
  const countryOptions: Array<MenuOption> = CountryArray.map((country) => ({
    value: country.code3,
    text: country.label,
  }));
  return (
    <Dropdown
      label=""
      accessibilityLabel="Country Selection"
      onSelect={props.onSelect}
      selectedValue={props.selectedValue}
      options={countryOptions}
    />
  );
}
